import React, { useCallback } from 'react'
import { Button } from '../../../../../../../../components/Button/Button'
import { RichTextFormatting, RichTextUndoRedo } from './hooks'
import classNames from 'classnames'

export interface RichTextButtonProps {
  formatting: RichTextFormatting
  undoRedo: RichTextUndoRedo
  disabled?: boolean
}

const Divider = () => <div className='mx-1 rich-text-toolbar-divider' />

export const RichTextButtons: React.FC<RichTextButtonProps> = ({ formatting, undoRedo, disabled = false }) => {
  const { isBold, isItalic, isUnderline, isStrikethrough, isLink, formatBold, formatItalic, formatUnderline, formatStrikethrough, insertLink } = formatting

  const { canUndo, canRedo, undo, redo } = undoRedo

  const getButtonStyle = useCallback((active: boolean = false) => {
    return classNames('p-1 fs-5 rich-text-button', { 'rich-text-button-active': active })
  }, [])

  return (
    <div className='d-flex flex-wrap gap-1 align-items-center flex-shrink-0 mw-100'>
      <Button variant='borderless' className={getButtonStyle(isBold)} onClick={formatBold} disabled={disabled}>
        <i className='bi bi-type-bold' />
      </Button>
      <Button variant='borderless' className={getButtonStyle(isItalic)} onClick={formatItalic} disabled={disabled}>
        <i className='bi bi-type-italic' />
      </Button>
      <Button variant='borderless' className={getButtonStyle(isUnderline)} onClick={formatUnderline} disabled={disabled}>
        <i className='bi bi-type-underline' />
      </Button>
      <Button variant='borderless' className={getButtonStyle(isStrikethrough)} onClick={formatStrikethrough} disabled={disabled}>
        <i className='bi bi-type-strikethrough' />
      </Button>
      <Divider />
      <Button variant='borderless' className={getButtonStyle(isLink)} onClick={insertLink} disabled={disabled}>
        <i className='bi bi-link' />
      </Button>
      <Divider />
      <Button variant='borderless' className={getButtonStyle()} disabled={!canUndo || disabled} onClick={undo}>
        <i className='bi bi-arrow-counterclockwise' />
      </Button>
      <Button variant='borderless' className={getButtonStyle()} disabled={!canRedo || disabled} onClick={redo}>
        <i className='bi bi-arrow-clockwise' />
      </Button>
    </div>
  )
}
